

















import { Component, Mixins } from "vue-property-decorator";
import { ObjectOptionSelectableMixin } from "./mixins";
import { QuotedBadge } from "./common";

@Component({
  components: {
    QuotedBadge,
  }
})
export default class WizardContentRadioSelectors extends Mixins(ObjectOptionSelectableMixin) {
}
